import * as React from "react";
import styled from "styled-components";

import Translate from "../../common/components/Translate";
import { createEntitiesConsumer } from "../../lib/entities";
import { Post, Profile, User } from "../entities";

const ProfileEntitiesConsumer = createEntitiesConsumer<{ profile: Profile }>({
  profile: "profiles",
});

const PostEntitiesConsumer = createEntitiesConsumer<{
  post: Post;
}>({ post: "posts" });

interface Props {
  user: User;
}

interface State {
  isHovered: boolean;
  isTouched: boolean;
}

class MembershipProfilePost extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isHovered: false,
      isTouched: false,
    };
  }

  public render() {
    const { user } = this.props;
    return (
      <ProfileEntitiesConsumer query={{ profile: user.profile }}>
        {({ profile }) =>
          profile && (
            <PostEntitiesConsumer query={{ post: profile.cover_post }}>{this.renderStory}</PostEntitiesConsumer>
          )
        }
      </ProfileEntitiesConsumer>
    );
  }

  public onToushStart = () => {
    this.setState({
      isTouched: true,
    });
  };

  public onMouseEnter = () => {
    this.setState({
      isHovered: true,
    });
  };

  public onMouseLeave = () => {
    this.setState({
      isHovered: false,
    });
  };

  public renderStory: typeof PostEntitiesConsumer.children = ({ post }) => {
    if (!post) {
      return null;
    }
    const { isHovered, isTouched } = this.state;
    const hover = isHovered && !isTouched;
    return (
      <StoryButton
        href={post.post_path}
        hover={hover}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        onTouchStart={this.onToushStart}
      >
        {hover ? (
          <HeadLine>
            <Translate id="company.members.story" />
          </HeadLine>
        ) : (
          <Icon className="icon icon-microphone" />
        )}
      </StoryButton>
    );
  };
}

const StoryButton = styled.a`
  display: block;
  background-color: rgba(0, 164, 187, 1);
  border-radius: 15px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  transition: all 100ms linear;
  &:hover {
    text-decoration: none;
  }
  width: ${(props: { hover: boolean }) => (props.hover ? "110px" : "30px")};
`;

const HeadLine = styled.span`
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  color: white;
`;

const Icon = styled.i`
  display: block;
  font-size: 14px;
  color: white;
`;

export default MembershipProfilePost;



// WEBPACK FOOTER //
// ./frontend/src/company_memberships/components/MembershipCardStory.tsx